export const enumUserOnboardingStepName = {
    INTRO : "Intro",
    CHOIX : "Choix",
    OFFREEMPLOIINTRO: "OffreEmploiIntro",
    FORMATIONINTRO:"FormationIntro",
    CONTRAT : "Contrat",
    FORMATION : "Formation",
    FIN : "Fin",
}